export const sellerPageTitles = {
    "/seller/dashboard": "Dashboard",
    "/seller/orders": "Orders",
    "/seller/products": "Products",
    "/seller/profile": "My Profile",
    "/seller/editProfile": "Edit Profile",
    "/seller/newOrder": "New Orders",
    "/seller/processing": "Processing Orders",
    "/seller/addProduct": "Add Product",
    "/seller/viewProduct": "View Products",
    "/seller/wallet": "Wallet",
};